const withGroupMovedDown = groupId => prevGroups => {
    const movedGroup = prevGroups.find(group => group.id === groupId);

    if (movedGroup) {
        return prevGroups.map(group => {
            // The changed group - it has moved down, so let's increase the position
            if (group.id === movedGroup.id) {
                return {
                    ...group,
                    position: group.position + 1,
                };
            }

            // The next group - it will be pushed up, so let's decrease the position
            const isNextGroup = group.position === movedGroup.position + 1;

            if (isNextGroup) {
                return {
                    ...group,
                    position: group.position - 1,
                };
            }

            // All other groups are left unchanged
            return group;
        });
    }

    return prevGroups;
};

export default withGroupMovedDown;
